var forms = require( './forms' );
var checkout_forms = require( './checkout-forms' );

var practice_details_popup = (function( $ ) {

	var $anchors;

	var _init = function() {
		if ( $( '#practice_details_form' ).length > 0 ) {
			return;
		}

		$anchors = $( 'a.update-practice-details' );

		if ( $anchors.length > 0 ) {
			$anchors.on( 'click', _maybe_show_popup );
		}
	};

	var _maybe_show_popup = function( e ) {
		e.preventDefault();

		if ( $( '#practice-details-popup' ).length > 0 || $( '.crate-popup' ).length > 0 ) {
			return;
		}

		var $anchor = $( this );

		var data = {
			crate_form_action: true,
			form_id: 'practice_details_form',
			action: 'crate_get_practice_details_popup',
			nonce: ScriptData.get_practice_details_popup_nonce,
		};

		$.get( ScriptData.ajaxurl, data, _maybe_show_popup_response );
	};

	var _maybe_show_popup_response = function( response ) {
		var $body = $( 'body' );

		$body.append( response.html );
		$body.addClass( 'popup-open' );

		var $popup_overlay = $( '.crate-popup-overlay' );
		var $popup         = $( '#practice-details-popup' );

		$popup_overlay.fadeIn();
		$popup.fadeIn();
		$popup.addClass( 'open' );

		$popup_overlay.on( 'click', _close_popup_event );
		$popup.find( 'a.close' ).on( 'click', _close_popup_event );

		var $form = $( '#practice_details_form' );

		$form.each( forms.init_forms );
		$form.on( 'saved', _practice_changed );
	};

	var _close_popup_event = function( e ) {
		e.preventDefault();

		_close_popup();
	};

	var _close_popup = function() {
		$( 'body' ).removeClass( 'popup-open' );

		var $popup = $( '#practice-details-popup' );
		var $popup_overlay = $( '.crate-popup-overlay' );

		$popup.fadeOut( 400 );
		$popup_overlay.fadeOut( 400 );

		setTimeout( function() {
			$popup.remove();
			$popup_overlay.remove();
		}, 400 );
	};

	var _practice_changed = function( e, response ) {
		if ( ! response.success || response.autosave ) {
			return;
		}

		if ( $( '#account-page' ).length > 0 ) {
			window.location.reload();
		} else {
			var $booking_info = $( '.checkout-booking-info' );

			if ( $booking_info.length > 0 ) {
				$booking_info.find( '.practice-location' ).text( response.practice_address );
			}

			var $diff_address = $( '#field_different_invoice_address' );

			if ( $diff_address.length > 0 && ! $diff_address.is( ':checked' ) ) {
				checkout_forms.change_invoice_address_fields();
			}

			_close_popup();
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = practice_details_popup;